export default __webpack_public_path__ + "static/media/a017-line6.89e77cbb.svg";